/// <reference path="Utilities/_reference.ts" />

module YVR.News {
	// Dependencies
	import logger = YVR.Utilities.Logger;
	import i18n = YVR.Utilities.I18n;

	// Default options
	const options = {
		error: null,
		isEmpty: null,
		pageSize: 10,
		serviceUrl: `/${i18n.getCurrentLanguage()}/_api/News`,
		year: null
	};

	// CSS Classes
	const classes = {
		block: 'yvr-news-listing',
		body: 'yvr-news__body',
		morebutton: 'yvr-news-listing__morebutton',
		moreBlock: 'yvr-article-listing__more-block',
		moreBlockHidden: 'yvr-article-listing__more-block--hidden'
	};

	// Cached jQuery elements
	const elements = {
		block: $(`.${classes.block}`)
	};

	// Cached data calls
	let cache = [];

	let currentPage = 0;
	let preLoad = 0;
	let lastMonthIndex = 0;
	let lastPost;

	function main() {
		const yearMatch = window.location.href.match('^.+\/years\/(.+)$');

		if (yearMatch) {
			options.year = yearMatch[1];
		}

		// Add initial blank table to page
		renderNews(options);

		runNews();
	}

	//#region News

	/**
	 * Get and render the news listing, removing any previous
	 */
	function runNews() {
		if (elements.block.length) {
			currentPage++;

			const odataFilter = elements.block.attr('data-odata-filter');

			getNews(options.year, odataFilter, currentPage)
				.then(checkForNoMore)
				.then(appendDataToCache)
				.then(transformNewsData)
				.then(renderNews)
				.then(focusNews)
				.fail(() => {
					console.error('[news][runNews] An error occured retrieving the news data.');

					options.error = true;
					options.isEmpty = false;

					renderNews(options);
				});
		}
	}

	/**
	 * Get the news data from the news service.
	 * @returns {obj} A jQuery promise that resolves with data from the news service.
	 */
	function getNews(year, filter, page) {
		const data: IODataQuery = {
			$orderby: 'Published desc',
			$top: options.pageSize
		};

		if (filter) {
			data.$filter = filter;
		} else if (year) {
			data.$filter = `year(Published) eq ${year}`;
		}

		if (page) {
			data.$skip = (page - 1) * options.pageSize;
		}

		return $.ajax({
			url: options.serviceUrl,
			type: 'GET',
			data,
			success(results) {
				logger.log('[news][getNews] Successfully retrieved news data.');
			}
		});
	}

	/**
	 * Hides the more button if a full page of items weren't returned.
	 * @returns {obj} A jQuery promise that resolves with original data.
	 */
	function checkForNoMore(data) {
		if (data.value.length < options.pageSize) {
			$(`.${classes.moreBlock}`).remove();
		} else {
			$(`.${classes.moreBlock}`).removeClass(classes.moreBlockHidden);
		}

		return data;
	}

	/**
	 * Appends the data just fetched to the local cache.
	 * @returns {obj} A jQuery promise that resolves with entire cached data.
	 */
	function appendDataToCache(data) {
		// Keep this data as cached
		cache = $.merge(cache, data.value);

		return cache;
	}


	/**
	 * Transform the data from the web service to be more user and template friendly.
	 * @returns {obj} A jQuery promise that resolves with transformed news data.
	 */
	function transformNewsData(data) {
		const model = {
			Months: []
		};

		// Loop through each news item
		for (let i = 0; i < data.length; i++) {
			const published = new Date(data[i].Published);
			const m = published.getMonth();
			const y = published.getFullYear();
			const monthName = (window as any).moment.months()[m];

			let month = GetMonthFromArray(model.Months, m, y);

			if (!month) {
				month = { 'MonthName': monthName, 'Month': m, 'Year': y, 'News': [] };
				model.Months.push(month);
			}

			const newsItem = data[i];
			month.News.push(newsItem);
		}

		return model;
	}

	function GetMonthFromArray(monthArray, month, year) {
		let _this;

		$.each(monthArray, function () {
			if (this.Month === month && this.Year === year) {
				_this = this;

				return false;
			}
		});

		return _this;
	}

	/**
	 * Render the news data using the news template.
	 */
	function renderNews(data) {
		const script = $('#yvr-news-template');

		if (script.length) {
			//const template = Handlebars.compile(script.html());
			let	template = YVR.templates.newsListing;
			const html = template(data);
			// Add the table right before the view all link
			$(`.${classes.body}`).html(html);
		}


	}

	function focusNews(data: any): void {
		if (preLoad == 1) {
			lastPost = $('.yvr-article-listing__post-title');
			if (lastMonthIndex + 1 <= lastPost.length - 1) {
				let newElement = $(lastPost[lastMonthIndex + 1]);

				$([document.documentElement, document.body]).animate({
					scrollTop: newElement.offset().top
				}, 2000);
				lastMonthIndex = lastPost.length - 1;

			}

		} else {
			lastPost = $('.yvr-article-listing__post-title');
			lastMonthIndex = lastPost.length - 1;
			preLoad = 1;
		}
	}

	$(`.${classes.morebutton}`).on('click', runNews);

	//#endregion


	main();
}
